import { render, staticRenderFns } from "./keyWords.html?vue&type=template&id=310d8c8b&"
import script from "./keyWords.js?vue&type=script&lang=js&"
export * from "./keyWords.js?vue&type=script&lang=js&"
import style0 from "./keyWords.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports